import { List, Select } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { Translate } from '@above-the-treeline/localization';
import ActiveFilters from '../../../Community/Administer/ActiveFilters';
import { useSavedCommunityFilters } from '../../../Community/containers/SavedCommunityFiltersDataStore';
import SaveAndCancelButtons from '../../../Community/UI/SaveAndCancelButtons/SaveAndCancelButtons';
import { replaceExclusion } from '../../../Community/util';
import LoadingSpinner from '../../../UI/LoadingSpinner';
import { useFilterOptions } from '../../containers/FilterOptionsDataStore';
import { useSavedFilter } from '../../containers/SavedFilterDataStore';
import SavedFilterTypes from '../../SavedFilterTypes';
import OptionSelectionTypes from '../OptionSelectionTypes';
import './addEditStandardFilters.less';

const { Option } = Select;

AddEditStandardFilters.propTypes = {
	browseRefinements: PropTypes.array,
	browseLaneType: PropTypes.object,
	leaveEditMode: PropTypes.func,
	savedFilterType: PropTypes.string,
};

function AddEditStandardFilters({
	browseRefinements,
	browseLaneType,
	leaveEditMode,
	savedFilterType,
}) {
	const [value, setValue] = React.useState(undefined);

	const filterOptionsDataStore = useFilterOptions();
	const { filterOptions, isLoading, filters } = filterOptionsDataStore.state;

	const [filterKeyToDisplay, setFilterKeyToDisplay] = React.useState('A');
	const [activeCategories, setActiveCategories] = React.useState([]);
	const filterSortButtons =
		!isLoading &&
		browseLaneType.optionSelectionType === OptionSelectionTypes.alpha &&
		Object.keys(filterOptions[browseLaneType.type]).sort();

	const savedFilterDataStore = useSavedFilter();

	const savedCommunityFiltersDataStore = useSavedCommunityFilters();

	React.useEffect(() => {
		const allSavedFilters = setSavedFilters(browseRefinements);
		setActiveCategories(allSavedFilters);
	}, []);

	const setSavedFilters = savedFilters => {
		const allSavedFilters =
			Array.isArray(savedFilters) &&
			savedFilters.map(filter => ({
				value: filter.code,
				label:
					filters.find(
						ff =>
							ff.type === browseLaneType.type &&
							ff.id === filter.code,
					) &&
					filters.find(
						ff =>
							ff.type === browseLaneType.type &&
							ff.id === filter.code,
					).displayName,
				isExclusion: filter.isExclusion,
			}));
		return allSavedFilters || [];
	};

	const removeFilter = value => {
		var newActiveCategories = activeCategories.filter(
			sec => sec.value !== value,
		);
		setActiveCategories(newActiveCategories);
	};

	const sortFilters = e => {
		setFilterKeyToDisplay(e.target.dataset.id);
	};

	const onClick = filter => {
		const filterToAdd = {
			value: filter.id,
			label: filter.displayName,
		};
		setActiveCategories([...activeCategories, filterToAdd]);
	};

	const saveFilters = () => {
		switch (savedFilterType) {
			case SavedFilterTypes.group:
				savedCommunityFiltersDataStore.saveFilters(
					activeCategories,
					browseLaneType,
				);
				break;
			case SavedFilterTypes.user:
				savedFilterDataStore.saveFilters(
					activeCategories,
					browseLaneType,
				);
				break;
		}
		leaveEditMode();
	};

	const onChange = value => {
		const ageRangeToAdd = {
			value: value,
			label: filters.find(
				ff => ff.type === browseLaneType.type && ff.id === value,
			).displayName,
		};
		setValue(value);
		setActiveCategories([...activeCategories, ageRangeToAdd]);
	};

	const changeExclusion = value => {
		const newActiveCategories = replaceExclusion(activeCategories, value);
		setActiveCategories(newActiveCategories);
	};

	const isNotUsed = key => {
		return activeCategories.filter(ac => ac.value === key).length === 0;
	};

	return (
		<div className="add-edit-standard-filters">
			{!isLoading && (
				<div className="bordered-container">
					{browseLaneType.optionSelectionType ===
						OptionSelectionTypes.select && (
						<div style={{ paddingBottom: 10 }}>
							<Select
								style={{ width: '100%' }}
								onChange={onChange}
								placeholder={<Translate id="please_select" />}
								value={value}>
								{filters
									.filter(
										ff => ff.type === browseLaneType.type,
									)
									.map(key => {
										return (
											isNotUsed(key.id) && (
												<Option value={key.id}>
													{key.displayName}
												</Option>
											)
										);
									})}
							</Select>
						</div>
					)}
					<ActiveFilters
						activeCategories={activeCategories}
						removeFilter={removeFilter}
						changeExclusion={changeExclusion}
					/>
					<SaveAndCancelButtons
						onSave={saveFilters}
						onCancel={leaveEditMode}
					/>
				</div>
			)}
			{browseLaneType.optionSelectionType ===
				OptionSelectionTypes.alpha && (
				<>
					<div className="sort-buttons">
						{filterSortButtons &&
							filterSortButtons.map(buttonText => (
								<p
									role="button"
									key={buttonText}
									onClick={sortFilters}
									data-id={buttonText}
									className="acc-font sort-button">
									{buttonText}
								</p>
							))}
					</div>
					<div className="standard-filter-selection">
						<List
							loading={{
								spinning: isLoading,
								indicator: <LoadingSpinner />,
							}}
							pagination={{
								pageSize: 15,
								hideOnSinglePage: true,
								simple: true,
							}}
							dataSource={
								isLoading
									? []
									: filterOptions[browseLaneType.type][
											filterKeyToDisplay
									  ]
							}
							renderItem={filter => (
								<List.Item>
									<p
										className="standard-filter-name"
										onClick={() => onClick(filter)}>
										{filter.name} (
										{filter.count.toLocaleString()})
									</p>
								</List.Item>
							)}
						/>
					</div>
				</>
			)}
		</div>
	);
}

export default AddEditStandardFilters;
